import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "C:/nexus/data-gh/guide/src/components/layout/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ColorDisp = makeShortcode("ColorDisp");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Colors`}</h1>
    <p>{`We want to use colors to highlight the important pattern we're trying to show with our charts. In the image below your eyes will automatically be drawn to the 3 dark red bars which are the noise complaints. `}</p>
    <img src="../../static/images/colorhighlights.png"></img>
    <p>{`The entire point of this chart is to show the noise complaints so this use of color is effective in highlighting this pattern.`}</p>
    <h2>{`Grays`}</h2>
    <p>{`In plots where we want to gray out bars or lines, this gray color looks nice. Plus, it's easy to remember, it's just "d3" 3 times.`}</p>
    <ColorDisp code="#d3d3d3" mdxType="ColorDisp"></ColorDisp>
If you have to have gray text, the above color is often too light so we can use a darker gray instead:
    <ColorDisp code="#adadad" mdxType="ColorDisp"></ColorDisp>
    <h2>{`Categories`}</h2>
    <p>{`If you only need 1 or two colors, always use a blue because it generally looks good.`}</p>
    <ColorDisp code="#4e79a7" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#f28e2c" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#e15759" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#76b7b2" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#59a14f" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#edc949" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#af7aa1" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#ff9da7" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#9c755f" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#bab0ab" mdxType="ColorDisp"></ColorDisp>
    <p>{`We can import the color scheme, from the 'd3-scale-chromatic' package.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { schemeTableau10 } from 'd3-scale-chromatic';

console.log(schemeTableau10) // array of hex codes for colors above ^
`}</code></pre>
    <p>{`We can also setup a scale to keep track of which color goes with each category.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { scaleOrdinal } from 'd3-scale';
const colorScale = scaleOrdinal().range(schemeTableau10);

colorScale("category1") // "#4e79a7
`}</code></pre>
    <p>{`Here are other nice colors to use:`}</p>
    <ColorDisp code="#08519C" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#005AA3" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#D96942" mdxType="ColorDisp"></ColorDisp>
    <ColorDisp code="#EDC949" mdxType="ColorDisp"></ColorDisp>
    <p>{`Try to avoid using the light values such as the yellow or pink unless you have a lot of categories. Don't use a
blue and yellow that look like UCSB colors together if the data is not from/about UCSB.`}</p>
    <p>{`If we need to change the color for a bar/text/arrow it's very difficult to look through code and know which hex codes to change.`}</p>
    <p><strong parentName="p">{`Please use objects to give hex codes labels and keep in them in one place`}</strong>{`. If you are using a blue and orange from the list above, create an object such as:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const colors = {
    blue: "#4e79a7",
    red: "#f28e2c"
}
`}</code></pre>
    <p>{`or category names such as:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const colors = {
    undergrads: "#4e79a7",
    grads: "#f28e2c"
}
`}</code></pre>
    <p>{`And then if you ever want to use that blue you can just give the value:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`colors.blue
`}</code></pre>
    <p>{`which will make the code a lot more readable and easier to change colors in the future`}</p>
    <h2>{`Continuous Colors`}</h2>
    <p>{`We can use continuous color scales such as the one below to emphasize the low and high values of continuous data.`}</p>
    <img src="../../static/images/colorScaleBlues.png" height="30px"></img>
    <p>{`The following code creates a scale to use this color scale:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { interpolateBlues } from 'd3-scale-chromatic';
import { scaleSequential } from 'd3-scale';

const colorScale = scaleSequential().interpolator(interpolateBlues);
colorScale(0) // color code
`}</code></pre>
    <p>{`For more colors you can checkout `}<a parentName="p" {...{
        "href": "https://github.com/d3/d3-scale-chromatic"
      }}>{`the d3 scale-chromatic docs`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      